<div nxLayout="grid maxwidth" class="policy-storno">
  <div nxRow>
    <div nxCol="12">
      <nx-link class="go-back">
        <a [routerLink]="['../']">
          <nx-icon name='chevron-left'></nx-icon>
          {{'policy.storno.go-back' | translate}}
        </a>
      </nx-link>
    </div>
  </div>
  <div nxRow>
    <div nxCol="12">
      <section
        *ngIf="!(loadingService.isLoading$ | async) || !this.terminationTypes">
        <nx-card>
          <!-- card header -->
          <nx-card-header
            *ngIf="policyDetail.policy.detailTypeIdentifier == 'CAR-INSURANCE'">
            <h3 nxHeadline="subsection-medium" class="title">
              {{ 'policy.storno.title-car' | translate }}
              ({{maInsurance.vehicle.crn}})</h3>
          </nx-card-header>

          <nx-card-header
            *ngIf="policyDetail.policy.detailTypeIdentifier == 'HOME-INSURANCE'">
            <h3 nxHeadline="subsection-medium" class="title">
              {{ 'policy.storno.title-home' | translate }}
              {{policyDetail.policy.householdAddress}}
            </h3>
          </nx-card-header>

          <div nxRow>
            <div nxCol="12">
              <!-- form start -->
              <form [formGroup]="cancelationForm" autocomplete="off"
                (submit)="submit($event)">

                <!-- Level 1 -->
                <div nxRow>
                  <div nxCol="12" class="termination-type">
                    <nx-radio-group formControlName="terminationType"
                      (groupValueChange)="resetSelections()">
                      <nx-label class="nx-margin-bottom-m">
                        {{
                        'policy.storno.form.termination-type' | translate
                        }}
                      </nx-label>
                      <ng-template ngFor let-terminationType="$implicit"
                        [ngForOf]="terminationTypes|keyvalue">
                        <nx-radio value="{{ terminationType.value.code }}"
                          class="nx-margin-bottom-m">
                          <span>{{ 'policy.storno.termination-type.'+terminationType.value.code | translate }}</span>
                          <span *ngIf="terminationType.value.code == 'B290'">
                            ({{ 'policy.storno.info-cancelation-date' |
                            translate }} {{closestPolicyEndDate | dateFormat }})
                          </span>
                          <br>
                          <span
                            *ngIf="this.cancelationForm.get('terminationType').value == 'B290' && terminationType.value.code == 'B290'">
                            {{ 'policy.storno.info-cancelation-date-text' |
                            translate }}
                          </span>
                        </nx-radio>
                      </ng-template>
                    </nx-radio-group>
                  </div>
                </div>

                <!-- block B290 set cancelationDate ??? -->
                <input nxInput type="text" class="d-none"
                  formControlName="cancelationDate" />
                <!-- LEVEL 2 -->
                <div nxRow class="agreements" *ngIf="showOtherPart">
                  <div nxCol="12" class="nx-margin-top-l">
                    <div
                      *ngIf="policyDetail.policy.detailTypeIdentifier == 'CAR-INSURANCE'">
                      <h3 nxHeadline="subsection-medium" translate
                        class="title">
                        {{ 'policy.storno.form.selected-policies-car' |
                        translate }}
                        ({{maInsurance.vehicle.crn}})</h3>
                      <ng-template ngFor let-mtplPolicy="$implicit"
                        [ngForOf]="getPoliciesToCancel()">
                        <p nxCopytext="large">
                          {{ mtplPolicy.policyNumber }} - {{
                          'claim.azk-lob.'+mtplPolicy.lobId | translate }} <span
                            *ngIf="mtplPolicy.paymentBlockageFlag"
                            class="blockage-flag"><b> {{
                              'policy.storno.form.blockage' |
                              translate }} </b></span>
                        </p>
                      </ng-template>
                    </div>

                    <div
                      *ngIf="policyDetail.policy.detailTypeIdentifier == 'HOME-INSURANCE'">
                      <h3 nxHeadline="subsection-medium" translate
                        class="title">
                        {{ 'policy.storno.form.selected-policies-home' |
                        translate }}
                        {{policyDetail.policy.householdAddress}}</h3>
                      <ng-template ngFor let-mtplPolicy="$implicit"
                        [ngForOf]="getPoliciesToCancel()">
                        <p nxCopytext="large">
                          {{ mtplPolicy.policyNumber }} - {{
                            'claim.azk-lob.'+mtplPolicy.lobId | translate }} <span
                            *ngIf="mtplPolicy.paymentBlockageFlag"
                            class="blockage-flag"><b> {{
                              'policy.storno.form.blockage' |
                              translate }} </b></span>
                        </p>
                      </ng-template>
                    </div>

                  </div>
                </div>


                <!-- level 3 -->
                <div nxRow *ngIf="showOtherPart" formGroupName="refunding">
                  <div nxCol="12" class="nx-margin-top-l">
                    <nx-radio-group formControlName="paymForm"
                      (groupValueChange)="resetRefundType()">
                      <nx-label class="nx-margin-bottom-m">
                        {{
                        'policy.storno.form.paym-form-text' | translate
                        }}</nx-label>

                      <ng-template ngFor let-paym="$implicit"
                        [ngForOf]="paymForm.values">

                        <!-- paymform radio button -->
                        <nx-radio value="{{ paym.id }}"
                          class="nx-margin-bottom-m">
                          {{ paymForm.getLabel(paym.name) | translate }}
                        </nx-radio>

                        <!-- sub options for radio buttons-->
                        <div formGroupName="paymFormOptions">

                          <!-- selected address -->
                          <div nxRow *ngIf="paym.name == 'ADDRESS'">
                            <div nxCol="12"
                              *ngIf="this.cancelationForm.get('refunding.paymForm').value == paym.id">
                              <nx-label>
                                {{ paymFormAddress.value }}
                              </nx-label>
                            </div>
                            <input nxInput #paymFormAddress type="text"
                              class="d-none" formControlName="address" />
                          </div>

                          <!-- selected bank account -->
                          <div nxRow *ngIf="paym.name == 'BANKACCOUNT'"
                            formGroupName="bankAccount"
                            class="nx-margin-left-m">
                            <div nxCol="12"
                              *ngIf="this.cancelationForm.get('refunding.paymForm').value == paym.id">

                              <nx-formfield label="{{ 'policy.storno.form.bank-account' | translate }}">
                                <nx-dropdown (ngModelChange)="resetIBAN()"
                                  formControlName="account">
                                  <ng-template ngFor let-account="$implicit"
                                    [ngForOf]="paymForm.getChoices(paym.name)">

                                    <nx-dropdown-item value="{{ account }}">
                                      {{ account }}
                                    </nx-dropdown-item>

                                  </ng-template>
                                  <nx-dropdown-item value="custom">
                                    {{
                                    'policy.storno.form.custom-bank-account-text'
                                    | translate }}
                                  </nx-dropdown-item>
                                </nx-dropdown>

                              </nx-formfield>

                              <!-- custom bank account -->
                              <nx-formfield label="IBAN" *ngIf="this.cancelationForm
                                  .get('refunding.paymFormOptions.bankAccount.account')
                                  .value == 'custom'">
                                <input nxInput nxMask nxIbanMask
                                  formControlName="customBankAccount" />
                              </nx-formfield>

                            </div>
                          </div>
                        </div>

                      </ng-template>

                    </nx-radio-group>
                  </div>
                </div>

                <div nxRow>
                  <div nxCol="12" class="button-right">
                    <button nxButton="primary normal" type="submit"
                      [disabled]="!this.cancelationForm.valid">
                      <span translate>policy.storno.form.submit-btn</span>
                    </button>
                  </div>
                </div>
              </form>

            </div>
          </div>

        </nx-card>
      </section>
    </div>
  </div>
</div>
